var _g, _g2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsvCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_25606",
    "data-name": "Group 25606",
    transform: "translate(-695 -383)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Container_56x56_Copy_30",
    "data-name": "Icon/Container/56x56 Copy 30",
    transform: "translate(695 383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Document_36dp_Copy_3",
    "data-name": "Icon/Document/36dp Copy 3",
    transform: "translate(705 393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Document",
    "data-name": "Icon/Document"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27,33H8.985A3,3,0,0,1,6,30V6A3,3,0,0,1,9,3H21l9,9V30A3,3,0,0,1,27,33ZM21,4.75h0V10.5A1.5,1.5,0,0,0,22.5,12h5.75L21,4.75Z",
    fill: "#217346"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(85.45 -97.118)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25605",
    "data-name": "Group 25605",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13991",
    "data-name": "Path 13991",
    d: "M627.736,511.125a3.773,3.773,0,0,1,3.718-4.1,3.271,3.271,0,0,1,2.375,1.019l-.984,1.128a1.835,1.835,0,0,0-1.343-.54c-1.031,0-1.859.912-1.859,2.423,0,1.559.732,2.459,1.823,2.459a1.981,1.981,0,0,0,1.5-.649l.972,1.1a3.245,3.245,0,0,1-2.531,1.151C629.415,515.118,627.736,513.764,627.736,511.125Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13992",
    "data-name": "Path 13992",
    d: "M634.252,513.979l.983-1.211a3.118,3.118,0,0,0,1.967.744c.708,0,1.032-.264,1.032-.684,0-.456-.42-.6-1.1-.876l-.995-.431a2.273,2.273,0,0,1-1.583-2.135,2.57,2.57,0,0,1,2.83-2.363,3.749,3.749,0,0,1,2.531.971l-.972,1.212a2.783,2.783,0,0,0-1.559-.576c-.575,0-.947.228-.947.636,0,.456.492.611,1.187.887l.972.4a2.139,2.139,0,0,1,1.547,2.123c0,1.307-1.092,2.446-2.974,2.446A4.162,4.162,0,0,1,634.252,513.979Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13993",
    "data-name": "Path 13993",
    d: "M640.444,507.167h1.967l.852,3.562c.216.851.383,1.643.611,2.495h.049c.227-.852.4-1.644.611-2.495l.936-3.562h1.894l-2.386,7.808h-2.243Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvCard);
export default __webpack_public_path__ + "static/media/csv-card.79a054902213559a1877b4a02648fc1f.svg";
export { ForwardRef as ReactComponent };